<template>
  <div class="section">
    <div v-if="isMaxScreen" class="page pc_page-4">
      <div class="section-4-image-container">
        <img
          :src="isES ? esPcPic : enPcPic"
          alt=""
          class="section-4-image"
        />
      </div>

    </div>
    <div v-else class="page page-4">
      <img
        :src="isES ? esMbPic : enMbPic"
        alt=""
        class="section-4-image"
      />

    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isES } from '@/locales';
export default {
  name: 'section4',
  components: {},
  data() {
    return {
      esPcPic: require('../../../assets/image/eu-home/es-pc-s4.png'),
      enPcPic: require('../../../assets/image/eu-home/en-pc-s4.png'),
      esMbPic: require('../../../assets/image/eu-home/es-mb-s4.png'),
      enMbPic: require('../../../assets/image/eu-home/en-mb-s4.png'),
      isES
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => {
        return state.isMaxScreen;
      }
    })
  },
  methods: {}
};
</script>
<style scoped lang="less">
@media (min-width: 981px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }

    .pc_page-4{
      background: #fff;
      padding: 120px 0;
      position: relative;
      overflow: hidden;
      .section-4-image-container{
        max-width: 1400px;
        margin: auto;
        .section-4-image{
          width: 100%;
        }
      }
    }
  }
}
@media (max-width: 980px) {
  .section {
    .page {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .page-4{
      background: #fff;
      padding: 120px 30px;
      width: calc(100% - 60px);
      .section-4-image{
        margin: auto;
        width: 100%;
      }
    }
  }
}
</style>
